import "reflect-metadata";
import Vue from "vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import App from "@/App.vue";

Vue.config.productionTip = false;
Vue.use(store);
new Vue({
  router,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
